<!-- This component route is used as a redirect page and could in the future feature a countdown to inform a user a redirect is happening. -->

<div class="row w-100 mx-0" style="min-height: 300px;">
    <div class="col-12 d-flex align-items-center justify-content-center">
        <lib-loading [status]="'text-info'" [spinnerPosition]="true" [text]="'LDG'" [size]="'md'"></lib-loading>
    </div>
</div>